import { ComparisonFilter } from '@logz-pkg/enums';
export class MetricsFilterModel {
    name;
    value;
    comparisonFilter = ComparisonFilter.Equal;
}
//# sourceMappingURL=metrics-filter.js.map